import { get, post, ajax_download, download, PreView } from "./Service";
import axios from "axios";
import { disconnectSocket,unsubscribeSocket } from "../components/socket";

const capturelastActivity = () => {
    localStorage.setItem('last_activity', Date.now());
};
export const getPresignedUrl = (
    { fileName, guid, menu_id, contextId, context, site_id, site_code, is_temp, user_id },
    onDone
) => {
    const params = new URLSearchParams({
        file_name: fileName,
        guid,
        menu_id,
        context_id: contextId,
        context,
        site_id,
        site_code,
        is_temp,
        user_id
    });

    get(`/api/minIO/presigned-upload?${params.toString()}`, onDone);
};

export const getPresignedUrls = async ({
    guid,
    menu_id,
    contextId,
    context,
    site_id,
    site_code,
    is_temp,
    user_id,
    temp_id,
    files
}) => {
    return fetch("/api/minIO/presigned-uploads", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",   // ✅ REQUIRED
            Authorization: "Bearer " + JSON.parse(sessionStorage.getItem('token')),
            'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify({
            guid,
            menu_id,
            context_id: contextId,
            context,
            site_id,
            site_code,
            is_temp,
            user_id,
            temp_id,
            files // [{ page_id, file_name }]
        })
    }).then(res => {
        if (!res.ok) throw new Error("Failed to get presigned URLs");
        return res.json();
    });
};
export const promoteFiles = (payload) => {
    return new Promise((resolve, reject) => {
        post("/api/minIO/promote-files", payload, (res) => {
            if (res?.error) {
                reject(res);
            } else {
                resolve(res);
            }
        });
    });
};

export const downloadMinioFile = async (path, fileName) => {
    try{
        const res = await fetch(path);

        // Check response
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        };

        // Validate content type (avoid HTML download issue)
        const contentType = res.headers.get("content-type");
        if (contentType?.includes("text/html")) {
            throw new Error("Received HTML instead of file. Check API URL.");
        };

        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);

        // DOWNLOAD MODE
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        return true;
    } catch(error) {
        console.error("Download failed:", error);
        return false;
    }
};
export const getUniqueId = (onDone) => {
    get("/api/attachments/get-uuid", (response) => {
        onDone(response.data);
    });
};

export const uploadFile = (file, fileName, guid, menu_id, contextId, context, site_id, onDone) => {
    post(encodeURI("/api/lego/upload-file/" + fileName + "/" + guid + "/" + menu_id + "/" + contextId + "/" + context + "/" + site_id), file, (res) => {
        onDone(res);
    });
};

export const getUploadedFile = ({ guid, contextId, context }, onDone) => {
    get(encodeURI("/api/attachments/get-uploaded-files/" + guid + "/" + contextId + "/" + context), (res) => {
        onDone(res);
    });
};

export const downloadFile = (id, onDone) => {
    ajax_download(encodeURI("/api/lego/download-file/" + id), (res) => {
        onDone(res);
    });
};
export const view = (id, onDone) => {
    PreView(encodeURI("/api/lego/download-file/" + id), (fileUrl) => {
        onDone(fileUrl);
    });
};


export const getImageData = (id, onDone) => {
    get(encodeURI("/api/lego/image-data-url/" + id), (res) => {
        onDone(res);
    });
};

export const getImageDataById = (id, onDone) => {
    capturelastActivity();

    axios({
        method: "get",
        url: encodeURI("/api/lego/image-data-url-by-id/" + id),
        responseType: "blob",   // ⭐ IMPORTANT
        headers: {
            Authorization: "Bearer " + JSON.parse(localStorage.getItem('token'))
        }
    }).then(res => {
        onDone(res.data);   // this is now a REAL Blob
    }).catch(error => {
        if (error.response?.status === 401) {
            disconnectSocket();
            localStorage.clear();
            window.location.href = "/login";
        }
    });
};

export const downloadReport = (module, type, fileName, payload, onDone) => {
    download(encodeURI("/api/lego/download-report/" + module + "/" + type + "/" + fileName), payload, (res) => {
        serveFile(fileName, res);
        onDone();
    });
};

export const getSaaSImageData = (id, onDone) => {
    get(encodeURI("/api/lego/saas-image-data-url/" + id), (res) => {
        onDone(res);
    });
};
export const uploadDocx = (formData, onDone) => {
    fetch("/api/lego/process-docx", {
        method: "POST",
        body: formData,
    })
    .then(res => res.json())
    .then(data => onDone(data))
    .catch(err => onDone({ status: "ERROR", error: err }));
};

let serveFile = (fileName, res) => {
    const url = window.URL.createObjectURL(new Blob([res]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
};
